export const tag = {
  Game: { value: "游戏" },
  Action: { value: "动作" },
  Anime: { value: "动漫" },
  Futanari: { value: "扶她", nsfw: true },
  Femboy: { value: "女性化男性" },
  Tomboy: { value: "假小子" },
  Comedy: { value: "喜剧" },
  OC: { value: "原创角色" },
  Fictional: { value: "虚构的" },
  Movie: { value: "电影" },
  Historical: { value: "历史的" },
  Royalty: { value: "皇室" },
  Detective: { value: "侦探" },
  Hero: { value: "英雄" },
  Villain: { value: "反派" },
  Magical: { value: "魔法" },
  Monster: { value: "怪物" },
  MonsterGirl: { value: "怪物娘" },
  Alien: { value: "外星人" },
  Robot: { value: "机器人" },
  Politics: { value: "政治" },
  Vampire: { value: "吸血鬼" },
  Giant: { value: "巨人" },
  Multiple: { value: "多人" },
  VTuber: { value: "虚拟主播" },
  Femdom: { value: "女性支配", nsfw: true },
  Dominant: { value: "支配的" },
  Submissive: { value: "顺从的" },
  MILF: { value: "熟女", nsfw: true },
  DILF: { value: "熟男", nsfw: true },
  Yandere: { value: "病娇" },
  Tsundere: { value: "傲娇" },
  Pokemon: { value: "宝可梦" },
  Assistant: { value: "助手" },
  NonEnglish: { value: "非英语" },
  Demon: { value: "恶魔" },
  Philosophy: { value: "哲学" },
  RPG: { value: "角色扮演游戏" },
  Religion: { value: "宗教" },
  Books: { value: "书籍" },
  Fairytale: { value: "童话" },
  Mythology: { value: "神话" },
  Gay: { value: "同性恋（男）" },
  Lesbian: { value: "同性恋（女）" },
  Bisexual: { value: "双性恋" },
  Kinky: { value: "性癖", nsfw: true },
  Seductive: { value: "诱惑的", nsfw: true },
  NTR: { value: "牛头人", nsfw: true },
  Fantasy: { value: "奇幻" },
  Straight: { value: "异性恋" },
  Vore: { value: "吞食", nsfw: true },
  SciFi: { value: "科幻" },
  Cheating: { value: "出轨", nsfw: true },
  BDSM: { value: "绑缚与调教", nsfw: true },
  CNC: { value: "假戏真做", nsfw: true },
  Vanilla: { value: "香草", nsfw: true },
  Omegaverse: { value: "ABO世界观" },
  Hetero: { value: "异性恋" },
  Horror: { value: "恐怖" },
  Mafia: { value: "黑手党" },
  Angel: { value: "天使" },
  Cute: { value: "可爱的" },
  Cartoon: { value: "卡通" },
  Caring: { value: "关怀的" },
  Friend: { value: "朋友" },
  Feral: { value: "野性的" },
  Expansion: { value: "扩张", nsfw: true },
  Corruption: { value: "腐化", nsfw: true },
  Kuudere: { value: "冷傲" },
  Story: { value: "故事" },
};
